import { render, staticRenderFns } from "./myvideo.vue?vue&type=template&id=1f3e5c75&scoped=true&"
import script from "./myvideo.vue?vue&type=script&lang=js&"
export * from "./myvideo.vue?vue&type=script&lang=js&"
import style0 from "./myvideo.vue?vue&type=style&index=0&id=1f3e5c75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e5c75",
  null
  
)

export default component.exports